// 39 Tehran districts where Arshe delivers employee food / catering.
// Each one becomes a /manategh/<slug> landing page. Real, manually written
// content per district — no auto-generated filler. Slugs are URL-safe Latin
// transliterations that still read as Persian to users.
export const DISTRICTS = [
    {
        slug: 'sohrevardi',
        name: 'سهروردی شمالی',
        zone: 'center',
        intro: 'سهروردی شمالی محل آشپزخانه‌ی مرکزی آرشه است — دفاتر این منطقه نزدیک‌ترین تحویل و بدون هزینه پیک را دریافت می‌کنند.',
        body: 'سهروردی شمالی از میدان هفت تیر تا میدان قندی، یکی از پرتراکم‌ترین خیابان‌های اداری مرکز تهران است. دفاتر شرکت‌های فناوری، خدماتی، رسانه و آژانس‌های دیجیتال در ساختمان‌های اطراف این خیابان و خیابان‌های فرعی (خرمشهر، قائم‌مقام، شهید قندی) متمرکز هستند.\n\n' +
            'آرشه آشپزخانه‌ی مرکزی خود را در همین منطقه — خیابان خرمشهر، بین کوچه میناب و گلشن، پلاک ۹ — اداره می‌کند. این یعنی برای شرکت‌های سهروردی، تحویل وعده ناهار در کوتاه‌ترین زمان ممکن انجام می‌شود و گرمای غذا کاملاً حفظ می‌شود. صبحانه کاری و پذیرایی جلسات نیز در همان روز و با هماهنگی کوتاه قابل ارائه است.',
        features: [
            'آشپزخانه مرکزی آرشه در همین خیابان',
            'بدون هزینه پیک — کوتاه‌ترین زمان تحویل',
            'صبحانه کاری با هماهنگی صبح همان روز',
            'پذیرایی جلسات و رویدادهای کاری در محل',
        ],
        nearby: ['shahid-beheshti', 'motahari', 'haft-tir', 'argentina'],
        postalRanges: '۱۵۵۷',
    },
    {
        slug: 'saadat-abad',
        name: 'سعادت‌آباد',
        zone: 'north',
        intro: 'سعادت‌آباد یکی از مهم‌ترین قطب‌های اداری و فناوری شمال تهران است. آشپزخانه آرشه در سهروردی شمالی قرار دارد و روزانه به شرکت‌های مستقر در سعادت‌آباد سرویس غذای کارمندی ارسال می‌کنیم.',
        body: 'سعادت‌آباد یکی از مهم‌ترین قطب‌های اداری و فناوری تهران است. شرکت‌های فعال در حوزه نرم‌افزار، فین‌تک، طراحی و تبلیغات در ساختمان‌های بلوار فرحزادی، خیابان علامه، میدان کاج و بلوار دریا متمرکز هستند. آرشه از آشپزخانه‌ی مرکزی خود در سهروردی شمالی، روزانه به دفاتر این منطقه سرویس می‌دهد.\n\n' +
            'برای شرکت‌های مستقر در سعادت‌آباد، تحویل وعده ناهار با هماهنگی قبلی و عبور از بزرگراه شیخ بهایی انجام می‌شود. منوی روزانه شامل غذاهای ایرانی پرسفارش (چلوکباب، خورشت‌ها، باقالی‌پلو) و گزینه‌های فرنگی و سبک است. صبحانه کاری و پذیرایی جلسات نیز برای مجموعه‌های سعادت‌آباد قابل ارائه است.',
        features: [
            'پوشش کامل بلوار فرحزادی، علامه و بلوار دریا',
            'تحویل با هماهنگی قبلی، با عبور از شیخ بهایی',
            'منوی ۴ تا ۶ گزینه‌ای روزانه با محوریت غذای ایرانی',
            'امکان پذیرایی جلسات و صبحانه کاری در محل',
        ],
        nearby: ['shahrak-gharb', 'farahzadi', 'sheikh-bahaei', 'pasdaran'],
        postalRanges: '۱۹۹۷–۱۹۹۸',
    },
    {
        slug: 'vanak',
        name: 'ونک',
        zone: 'center',
        intro: 'میدان ونک قلب اقتصادی تهران است — آرشه به شرکت‌های مستقر در برج‌های ونک، گاندی و میرداماد سرویس روزانه می‌دهد.',
        body: 'ونک با تراکم بالای دفاتر مالی، بانک‌ها و شرکت‌های سرمایه‌گذاری، یکی از پرتقاضاترین مناطق برای خدمات غذای کارمندی است. آرشه با تجربه چندساله در این منطقه، آشنایی کاملی با پارکینگ‌های شلوغ، ساعات اوج ترافیک و نیازهای متفاوت پرسنل بانکی، فناوری و خدمات حرفه‌ای دارد.\n\n' +
            'برای شرکت‌های ونک، گاندی، میرداماد و جردن، تحویل به‌صورت کاملاً برنامه‌ریزی‌شده انجام می‌شود تا با اوج ترافیک منطقه برخورد نکند. منوی روزانه شامل گزینه‌های سبک‌تر برای کارمندان دفتری (سالاد، خوراک گریل) و وعده‌های کامل ایرانی است.',
        features: [
            'تحویل قبل از اوج ترافیک ساعت ۱۲',
            'تنوع منو با گزینه‌های سبک برای کارمندان بانکی و فناوری',
            'پذیرایی جلسات و رویدادهای کاری',
            'تجربه چندساله در ساختمان‌های مرتفع ونک و گاندی',
        ],
        nearby: ['mirdamad', 'jordan', 'argentina', 'gandi'],
    },
    {
        slug: 'mirdamad',
        name: 'میرداماد',
        zone: 'center',
        intro: 'بلوار میرداماد محل استقرار شرکت‌های بزرگ تبلیغاتی، رسانه‌ای و فناوری است — آرشه روزانه به این مجموعه‌ها سرویس می‌دهد.',
        body: 'میرداماد یکی از پرتراکم‌ترین خیابان‌های اداری تهران است که از میدان مادر تا تقاطع آفریقا (جردن) امتداد دارد. آژانس‌های تبلیغاتی، شرکت‌های توسعه نرم‌افزار، استارتاپ‌ها و دفاتر منطقه‌ای شرکت‌های چندملیتی در این منطقه متمرکز هستند.\n\n' +
            'آرشه برای شرکت‌های میرداماد سرویس کیترینگ روزانه، صبحانه کاری و وعده‌های پذیرایی جلسات را ارائه می‌دهد. منوی روزانه با همکاری مدیر شرکت تنظیم می‌شود تا با ذائقه عمومی پرسنل هماهنگ باشد.',
        features: [
            'سرویس روزانه به آژانس‌های تبلیغاتی و رسانه‌ای',
            'گزینه ویژه صبحانه کاری برای جلسات صبح',
            'تنوع منو متناسب با تیم‌های جوان',
            'تحویل با هماهنگی پارکینگ ساختمان',
        ],
        nearby: ['vanak', 'jordan', 'argentina', 'shariati'],
    },
    {
        slug: 'pasdaran',
        name: 'پاسداران',
        zone: 'north',
        intro: 'پاسداران منطقه‌ای ترکیبی از دفاتر اداری، سفارت‌خانه‌ها و شرکت‌های فناوری است — آرشه برای هر سه دسته منوی متناسب طراحی می‌کند.',
        body: 'پاسداران از میدان نوبنیاد تا تقاطع شریعتی امتداد دارد و یکی از مناطق ویژه‌ی تهران از نظر تنوع مشتری اداری است. شرکت‌های فعال در حوزه طراحی، معماری، فناوری و خدمات تخصصی در این منطقه دفتر دارند.\n\n' +
            'آرشه برای شرکت‌های پاسداران، نیاوران و فرمانیه با هماهنگی مدیر مجموعه، منوی هفتگی را طراحی می‌کند. سرویس برای دفاتر کوچک ۲۰ نفری تا مجموعه‌های ۱۵۰ نفری قابل تنظیم است.',
        features: [
            'پوشش از نوبنیاد تا تقاطع شریعتی',
            'منوی متناسب با تیم‌های طراحی و معماری',
            'گزینه‌های گیاهی و رژیمی به‌صورت روزانه',
            'تحویل با هماهنگی پذیرش ساختمان',
        ],
        nearby: ['niavaran', 'farmanieh', 'shariati', 'qeytarieh'],
    },
    {
        slug: 'niavaran',
        name: 'نیاوران',
        zone: 'north',
        intro: 'دفاتر اداری و ادارات خصوصی نیاوران از سرویس کیترینگ آرشه برای پذیرایی و وعده‌های روزانه استفاده می‌کنند.',
        body: 'نیاوران به‌عنوان یکی از مناطق برخوردار شمال تهران، میزبان دفاتر مدیریتی شرکت‌های بزرگ، باشگاه‌ها و مؤسسات فرهنگی است. تقاضای منطقه عمدتاً برای وعده‌های باکیفیت بالا و پذیرایی جلسات است.\n\n' +
            'آرشه با تجربه پذیرایی از جلسات هیئت‌مدیره و رویدادهای کاری در نیاوران، گزینه‌های ویژه‌ای از منو را برای این منطقه طراحی کرده است. هزینه پیک برای مجموعه‌های ۳۰ نفر به بالا رایگان است.',
        features: [
            'پذیرایی جلسات و رویدادهای کاری',
            'منوی ویژه با محصولات کیفیت بالا',
            'تحویل به دفاتر کوچک و بزرگ',
            'هماهنگی با نگهبانی برای دسترسی سریع',
        ],
        nearby: ['pasdaran', 'farmanieh', 'tajrish', 'darrous'],
    },
    {
        slug: 'tajrish',
        name: 'تجریش',
        zone: 'north',
        intro: 'مجتمع‌های اداری تجریش و انتهای ولیعصر از سرویس روزانه آرشه استفاده می‌کنند — تحویل قبل از ظهر تضمین می‌شود.',
        body: 'تجریش یکی از مناطق پرتراکم تهران از نظر اداری و تجاری است. شرکت‌های فعال در حوزه گردشگری، خدمات حقوقی و دفاتر منطقه‌ای در ساختمان‌های اطراف میدان تجریش و خیابان شریعتی شمال متمرکز هستند.\n\n' +
            'آرشه برای شرکت‌های تجریش، قیطریه و دزاشیب سرویس ناهار روزانه و گزینه پذیرایی رویدادها را ارائه می‌دهد. ترافیک سنگین منطقه با برنامه‌ریزی دقیق تحویل قبل از ساعت ۱۲ مدیریت می‌شود.',
        features: [
            'تحویل تضمینی قبل از ساعت ۱۲ صبح',
            'منوی ویژه دفاتر گردشگری و حقوقی',
            'پذیرایی رویدادهای فرهنگی و کاری',
            'پوشش از میدان تجریش تا قیطریه',
        ],
        nearby: ['qeytarieh', 'darrous', 'niavaran', 'shariati'],
    },
    {
        slug: 'shahrak-gharb',
        name: 'شهرک غرب',
        zone: 'west',
        intro: 'شهرک غرب یکی از قطب‌های اصلی شرکت‌های فناوری و استارتاپی تهران است — آرشه سرویس ویژه تیم‌های جوان ارائه می‌دهد.',
        body: 'شهرک غرب با مجتمع‌های اداری بزرگ مانند برج میلاد، گلستان، و ایران‌زمین، یکی از پرتقاضاترین مناطق برای خدمات غذای کارمندی است. شرکت‌های فعال در حوزه نرم‌افزار، تجارت الکترونیک و فین‌تک در این منطقه متمرکز شده‌اند.\n\n' +
            'آرشه با شناخت کامل از ذائقه تیم‌های جوان فناوری، منوی متعادلی از غذای ایرانی، فست‌فود سالم و گزینه‌های گیاهی برای شرکت‌های شهرک غرب طراحی می‌کند. تحویل به ساختمان‌های ایران‌زمین و گلستان به صورت روزانه و هماهنگ با نگهبانی انجام می‌شود.',
        features: [
            'سرویس به مجتمع‌های ایران‌زمین، گلستان و میلاد',
            'منوی متناسب با ذائقه تیم‌های فناوری',
            'گزینه‌های گیاهی و فست‌فود سالم',
            'بدون هزینه پیک برای منطقه ۲',
        ],
        nearby: ['saadat-abad', 'farahzadi', 'punak', 'sadeghieh'],
    },
    {
        slug: 'farahzadi',
        name: 'فرحزادی',
        zone: 'west',
        intro: 'بلوار فرحزادی محل استقرار دفاتر منطقه‌ای شرکت‌های بزرگ و بیمارستان‌های خصوصی است — آرشه سرویس متناسب با هر دو ارائه می‌دهد.',
        body: 'بلوار فرحزادی به دلیل قرار گرفتن در نزدیکی بزرگراه نیایش، دسترسی سریع به مناطق مختلف تهران را فراهم می‌کند. شرکت‌های مستقر در ساختمان‌های اداری این بلوار و بیمارستان‌های اطراف، نیاز روزانه به وعده غذای کارمندی دارند.\n\n' +
            'آرشه برای پرسنل بیمارستان‌ها گزینه‌های سبک‌تر (سوپ، خوراک گریل، سالاد) و برای کارمندان اداری منوی کامل ایرانی ارائه می‌دهد. تحویل با هماهنگی شیفت‌های بیمارستانی نیز قابل تنظیم است.',
        features: [
            'سرویس به بیمارستان‌های خصوصی منطقه',
            'منوی شیفت‌بندی شده برای پرسنل درمانی',
            'گزینه‌های سبک‌تر و رژیمی',
            'تحویل با هماهنگی واحدهای مختلف',
        ],
        nearby: ['saadat-abad', 'shahrak-gharb', 'sheikh-bahaei', 'punak'],
    },
    {
        slug: 'jordan',
        name: 'جردن (آفریقا)',
        zone: 'center',
        intro: 'خیابان جردن (آفریقا) محل دفاتر شرکت‌های بزرگ ایرانی و خدمات حرفه‌ای است — آرشه روزانه به این منطقه سرویس می‌دهد.',
        body: 'خیابان آفریقا (جردن) از پل میرداماد تا میدان آرژانتین امتداد دارد و یکی از مهم‌ترین خیابان‌های اداری تهران است. دفاتر مرکزی بانک‌ها، شرکت‌های هلدینگ و دفاتر منطقه‌ای شرکت‌های بزرگ در این منطقه قرار دارند.\n\n' +
            'آرشه با تجربه پذیرایی از مجموعه‌های بزرگ جردن و آفریقا، توان تحویل سفارش‌های صد‌نفری به بالا را در همان روز دارد. فاکتور رسمی و گزارش مالی ماهانه برای واحدهای حسابداری شرکت‌های منطقه فراهم می‌شود.',
        features: [
            'توان تحویل سفارش ۱۰۰ نفر به بالا',
            'فاکتور رسمی برای واحدهای حسابداری بزرگ',
            'سرویس به شرکت‌های هلدینگ و بانک‌ها',
            'تجربه چندساله در ساختمان‌های مرتفع آفریقا',
        ],
        nearby: ['vanak', 'mirdamad', 'argentina', 'shariati'],
    },
    {
        slug: 'argentina',
        name: 'آرژانتین',
        zone: 'center',
        intro: 'میدان آرژانتین و خیابان احمد قصیر، مرکز شرکت‌های مالی و خدمات حقوقی است — آرشه برای این مجموعه‌ها منوی استاندارد ارائه می‌دهد.',
        body: 'منطقه آرژانتین یکی از کلاسیک‌ترین مناطق اداری تهران است. ساختمان‌های قدیمی و جدید این منطقه میزبان دفاتر حقوقی، شرکت‌های ثبت، حسابرسی و مشاوره مدیریت هستند.\n\n' +
            'برای شرکت‌های منطقه آرژانتین، آرشه منوی روزانه‌ای از غذاهای ایرانی کلاسیک و گزینه‌های سبک طراحی می‌کند. هزینه پیک رایگان و فاکتور ماهانه از مزایای قراردادهای منطقه است.',
        features: [
            'سرویس روزانه به دفاتر حقوقی و حسابرسی',
            'منوی غذای ایرانی کلاسیک',
            'تحویل به‌موقع با هماهنگی پارکینگ',
            'فاکتور رسمی ماهانه',
        ],
        nearby: ['jordan', 'haft-tir', 'vanak', 'mirdamad'],
    },
    {
        slug: 'haft-tir',
        name: 'هفت تیر',
        zone: 'center',
        intro: 'میدان هفت تیر یکی از قدیمی‌ترین مراکز تجاری اداری تهران است — آرشه به دفاتر مستقر در ساختمان‌های اطراف سرویس می‌دهد.',
        body: 'میدان هفت تیر و خیابان مفتح، محل دفاتر شرکت‌های واردات، صادرات، آژانس‌های مسافرتی و دفاتر اسناد رسمی است. تراکم بالای دفاتر کوچک و متوسط در این منطقه، نیاز روزانه به سرویس وعده ناهار را ایجاد کرده است.\n\n' +
            'آرشه با امکان سرویس‌دهی به دفاتر کوچک ۸ نفر به بالا، انتخاب مناسبی برای مجموعه‌های منطقه هفت تیر است. منوی روزانه ساده و متنوع، مناسب ذائقه عمومی.',
        features: [
            'سرویس به دفاتر کوچک از ۸ نفر',
            'منوی ساده و متنوع روزانه',
            'مناسب آژانس‌های مسافرتی و دفاتر ثبت',
            'تحویل به ساختمان‌های قدیمی منطقه',
        ],
        nearby: ['argentina', 'motahari', 'shahid-beheshti', 'enghelab'],
    },
    {
        slug: 'shahid-beheshti',
        name: 'شهید بهشتی (عباس‌آباد)',
        zone: 'center',
        intro: 'خیابان شهید بهشتی محل دفاتر دولتی، نیمه‌دولتی و خصوصی است — آرشه از همین منطقه آشپزخانه‌ی اصلی خود را اداره می‌کند و سریع‌ترین تحویل را به این خیابان دارد.',
        body: 'خیابان شهید بهشتی از خیابان مفتح تا قائم‌مقام، یکی از پرتراکم‌ترین خیابان‌های اداری مرکز تهران است. دفاتر دولتی و نیمه‌دولتی همراه با شرکت‌های خصوصی متوسط در این منطقه متمرکز هستند. آشپزخانه‌ی مرکزی آرشه نیز در سهروردی شمالی (خیابان خرمشهر، بین کوچه میناب و گلشن) قرار دارد — یعنی فاصله‌ی پیاده‌ی کوتاه از بسیاری از دفاتر این منطقه.\n\n' +
            'آرشه با ارائه فاکتور رسمی و مدارک قابل ارائه به واحدهای حسابداری دولتی، انتخاب مناسبی برای این منطقه است. منوی روزانه شامل غذای ایرانی استاندارد و مناسب همه ذائقه‌ها است. تحویل وعده ناهار به‌خاطر نزدیکی، در کوتاه‌ترین زمان ممکن انجام می‌شود.',
        features: [
            'آشپزخانه مرکزی آرشه در همین محله — کوتاه‌ترین زمان تحویل',
            'بدون هزینه پیک برای دفاتر بهشتی، سهروردی و خرمشهر',
            'فاکتور رسمی برای واحدهای دولتی',
            'منوی استاندارد ایرانی، تحویل به‌موقع تضمینی',
        ],
        nearby: ['haft-tir', 'motahari', 'argentina', 'enghelab'],
    },
    {
        slug: 'enghelab',
        name: 'انقلاب',
        zone: 'center',
        intro: 'خیابان انقلاب محل دفاتر انتشاراتی، فرهنگی و دانشگاهی است — آرشه برای پرسنل این دفاتر منوی روزانه ارائه می‌دهد.',
        body: 'خیابان انقلاب از میدان فردوسی تا میدان انقلاب، مرکز نشر، فرهنگ و خدمات دانشگاهی تهران است. انتشارات بزرگ، دفاتر مجلات، آژانس‌های ادبی و دفاتر مشاوره تحصیلی در این منطقه متمرکز هستند.\n\n' +
            'آرشه با شناخت ذائقه پرسنل فرهنگی و دانشگاهی، منوی متعادلی از غذای ایرانی و گزینه‌های سبک ارائه می‌دهد. هزینه پیک برای منطقه ۶ رایگان است.',
        features: [
            'سرویس به انتشارات و دفاتر فرهنگی',
            'منوی متعادل ایرانی و سبک',
            'هزینه پیک رایگان منطقه ۶',
            'مناسب دفاتر کوچک و متوسط',
        ],
        nearby: ['valiasr', 'haft-tir', 'shahid-beheshti', 'ferdowsi'],
    },
    {
        slug: 'valiasr',
        name: 'ولیعصر',
        zone: 'center',
        intro: 'خیابان ولیعصر طولانی‌ترین خیابان تهران است — آرشه به شرکت‌های مستقر در طول این خیابان از تجریش تا راه‌آهن سرویس می‌دهد.',
        body: 'خیابان ولیعصر با طول حدود ۱۸ کیلومتر، طولانی‌ترین خیابان تهران است و در طول آن دفاتر اداری متنوعی از شمال تا جنوب شهر مستقر هستند. آرشه با تقسیم منطقه به چند زون تحویل، روزانه به شرکت‌های مختلف ولیعصر سرویس می‌دهد.\n\n' +
            'بسته به موقعیت دقیق دفتر شما در ولیعصر (شمال، مرکز یا جنوب)، زمان تحویل و هزینه ارسال متفاوت است. تماس بگیرید تا برنامه دقیق برای آدرس شما طراحی شود.',
        features: [
            'پوشش از تجریش تا راه‌آهن',
            'تقسیم به زون‌های تحویل برای زمان‌بندی دقیق',
            'منوی روزانه استاندارد',
            'فاکتور ماهانه و گزارش‌گیری',
        ],
        nearby: ['enghelab', 'tajrish', 'argentina', 'haft-tir'],
    },
    {
        slug: 'yousefabad',
        name: 'یوسف‌آباد',
        zone: 'center',
        intro: 'یوسف‌آباد یکی از مناطق قدیمی و خوش‌نشین مرکز تهران است — آرشه به دفاتر اداری منطقه سرویس روزانه می‌دهد.',
        body: 'منطقه یوسف‌آباد با ترکیبی از مسکونی و اداری، میزبان شرکت‌های متوسط، دفاتر مشاوره و آژانس‌های دیجیتال است. تراکم ساختمان‌های اداری کوچک و متوسط در این منطقه بالا است.\n\n' +
            'آرشه برای شرکت‌های یوسف‌آباد منوی متنوع و پرحجم روزانه را با هزینه پیک رایگان ارائه می‌دهد. مناسب دفاتر ۱۵ نفر به بالا.',
        features: [
            'سرویس به دفاتر متوسط منطقه ۶',
            'منوی متنوع و پرحجم',
            'هزینه پیک رایگان',
            'تحویل سریع به ساختمان‌های قدیمی',
        ],
        nearby: ['fatemi', 'shahid-beheshti', 'enghelab', 'valiasr'],
    },
    {
        slug: 'fatemi',
        name: 'فاطمی',
        zone: 'center',
        intro: 'میدان فاطمی محل ادارات دولتی و مرکزی شرکت‌های بزرگ است — آرشه با فاکتور رسمی به این مجموعه‌ها سرویس می‌دهد.',
        body: 'منطقه فاطمی، گلها و کشاورز محل ادارات مرکزی و دفاتر منطقه‌ای شرکت‌های بزرگ است. تراکم بالای ادارات دولتی نیز در این منطقه دیده می‌شود.\n\n' +
            'آرشه با تجربه کار با سیستم‌های پرداخت و حسابداری سازمانی، انتخابی قابل اعتماد برای مجموعه‌های منطقه است. منوی روزانه استاندارد ایرانی با امکان سفارش‌گیری گروهی.',
        features: [
            'سرویس به ادارات و شرکت‌های بزرگ',
            'فاکتور رسمی برای حسابداری دولتی',
            'منوی استاندارد ایرانی',
            'تجربه با سفارش‌های ۱۰۰ نفر به بالا',
        ],
        nearby: ['yousefabad', 'keshavarz', 'valiasr', 'enghelab'],
    },
    {
        slug: 'keshavarz',
        name: 'بلوار کشاورز',
        zone: 'center',
        intro: 'بلوار کشاورز محل دفاتر شرکت‌های بزرگ، دانشگاه‌ها و بیمارستان‌های دولتی است.',
        body: 'بلوار کشاورز با عبور از وزارت کشاورزی و دانشگاه‌های مهم تهران، یکی از پررفت‌و‌آمدترین مناطق مرکز شهر است. تقاضای منطقه ترکیبی از سرویس ناهار ادارات، پرسنل دانشگاهی و درمانی است.\n\n' +
            'آرشه با شناخت ذائقه متنوع منطقه، منوی متعادلی از غذای ایرانی، گزینه‌های سبک‌تر برای پرسنل درمانی و گزینه‌های اقتصادی برای دفاتر دانشجویی ارائه می‌دهد.',
        features: [
            'سرویس به ادارات و دانشگاه‌ها',
            'گزینه‌های اقتصادی برای دفاتر کوچک',
            'منوی سبک برای پرسنل درمانی',
            'پوشش از میدان ولیعصر تا چهارراه فلسطین',
        ],
        nearby: ['fatemi', 'valiasr', 'enghelab', 'yousefabad'],
    },
    {
        slug: 'qeytarieh',
        name: 'قیطریه',
        zone: 'north',
        intro: 'قیطریه میزبان دفاتر مدیریتی شرکت‌های بزرگ و استارتاپ‌های نوپا است — آرشه برای هر دو دسته منوی متناسب طراحی می‌کند.',
        body: 'محله قیطریه با پارک معروف و فضای سبز فراوان، یکی از مناطق محبوب برای دفاتر مدیریتی و استارتاپ‌های کوچک شده است. ساختمان‌های اداری مدرن این منطقه پذیرای شرکت‌های متوسط هستند.\n\n' +
            'آرشه با تجربه سرویس به استارتاپ‌های قیطریه و دفاتر مدیریتی، گزینه‌های متنوعی از منوی روزانه ارائه می‌دهد. هزینه پیک برای دفاتر ۲۰ نفر به بالا رایگان است.',
        features: [
            'سرویس به استارتاپ‌ها و دفاتر مدیریتی',
            'گزینه‌های مدرن و سنتی در منو',
            'پیک رایگان برای ۲۰ نفر به بالا',
            'تحویل با هماهنگی ساختمان',
        ],
        nearby: ['tajrish', 'farmanieh', 'darrous', 'shariati'],
    },
    {
        slug: 'darrous',
        name: 'دروس',
        zone: 'north',
        intro: 'دروس محله‌ای ترکیبی از مسکونی و دفاتر اداری شیک است — آرشه برای مجموعه‌های منطقه پذیرایی متمایز ارائه می‌دهد.',
        body: 'محله دروس به دلیل موقعیت آرام و ساختمان‌های زیبا، محل دفاتر طراحی، معماری، و شرکت‌های مشاوره خصوصی است. مشتریان این منطقه به‌دنبال کیفیت بالا و خدمات لوکس‌تر هستند.\n\n' +
            'آرشه برای شرکت‌های دروس منوی پریمیوم با ارائه بهتر و گزینه‌های متمایز فراهم می‌کند. مناسب دفاتر ۱۵ تا ۵۰ نفری.',
        features: [
            'منوی پریمیوم با ارائه متمایز',
            'مناسب دفاتر طراحی و معماری',
            'گزینه‌های سالم و ارگانیک',
            'پذیرایی جلسات با کیفیت بالا',
        ],
        nearby: ['qeytarieh', 'shariati', 'niavaran', 'farmanieh'],
    },
    {
        slug: 'shariati',
        name: 'شریعتی',
        zone: 'east',
        intro: 'خیابان شریعتی از سیدخندان تا قلهک محل دفاتر اداری متنوعی است — آرشه به همه قسمت‌های این خیابان سرویس می‌دهد.',
        body: 'خیابان شریعتی با طول طولانی خود از قلهک تا سیدخندان، انواع متفاوتی از کسب‌وکارها را در طول مسیر دارد. در قسمت شمالی دفاتر مدیریتی و در قسمت میانی شرکت‌های متوسط و دفاتر فنی متمرکز هستند.\n\n' +
            'آرشه با تقسیم خیابان شریعتی به چند زون، تحویل به‌موقع را در ساعات اوج ترافیک تضمین می‌کند. منوی روزانه برای هر زون با توجه به نوع کسب‌وکار تنظیم می‌شود.',
        features: [
            'پوشش از قلهک تا سیدخندان',
            'تقسیم به زون‌های زمان‌بندی',
            'منوی متناسب با نوع کسب‌وکار',
            'تحویل با شناخت ترافیک محلی',
        ],
        nearby: ['qeytarieh', 'haft-tir', 'darrous', 'mirdamad'],
    },
    {
        slug: 'tehranpars',
        name: 'تهرانپارس',
        zone: 'east',
        intro: 'تهرانپارس از مهم‌ترین قطب‌های تجاری شرق تهران است — آرشه با هماهنگی برای مجموعه‌های منطقه سرویس روزانه ارائه می‌دهد.',
        body: 'تهرانپارس با فلکه‌های اول تا سوم خود، یکی از پرتراکم‌ترین مناطق تجاری اداری شرق تهران است. شرکت‌های واردات، توزیع، و دفاتر منطقه‌ای در این منطقه دفتر دارند.\n\n' +
            'آرشه با هماهنگی روزانه به تهرانپارس سرویس می‌دهد. به دلیل فاصله از آشپزخانه مرکزی، هزینه پیک از حدی به بالا اعمال می‌شود که برای مجموعه‌های بزرگ توافقی است.',
        features: [
            'سرویس به فلکه‌های اول، دوم و سوم',
            'مناسب شرکت‌های واردات و توزیع',
            'هزینه پیک توافقی برای مجموعه‌های بزرگ',
            'تحویل با هماهنگی روز قبل',
        ],
        nearby: ['narmak', 'resalat', 'shariati', 'sayyad-shirazi'],
    },
    {
        slug: 'narmak',
        name: 'نارمک',
        zone: 'east',
        intro: 'نارمک یکی از مناطق قدیمی شرق تهران با تراکم بالای دفاتر اداری متوسط است.',
        body: 'محله نارمک ترکیبی از کاربری مسکونی و اداری دارد. شرکت‌های تولیدی متوسط، دفاتر فنی و آژانس‌های خدماتی در ساختمان‌های قدیمی و جدید این منطقه فعال هستند.\n\n' +
            'آرشه به نارمک سرویس ناهار روزانه با گزینه‌های متنوع غذای ایرانی ارائه می‌دهد. مناسب دفاتر ۲۰ تا ۸۰ نفری.',
        features: [
            'سرویس به دفاتر تولیدی و فنی',
            'منوی غذای ایرانی متنوع',
            'تحویل به ساختمان‌های قدیمی منطقه',
            'مناسب دفاتر ۲۰ نفر به بالا',
        ],
        nearby: ['tehranpars', 'resalat', 'shariati', 'sayyad-shirazi'],
    },
    {
        slug: 'resalat',
        name: 'بزرگراه رسالت',
        zone: 'east',
        intro: 'بزرگراه رسالت مسیر دسترسی به مجتمع‌های اداری شرق تهران است — آرشه با برنامه‌ریزی ترافیک، تحویل به موقع تضمین می‌کند.',
        body: 'بزرگراه رسالت با عبور از مناطق نارمک، تهرانپارس و حکیمیه، مسیر دسترسی به مجتمع‌های اداری و دفاتر کسب‌وکار شرق تهران است. تراکم ساعت ۸ تا ۱۰ صبح و ۴ تا ۷ عصر بسیار بالاست.\n\n' +
            'آرشه تحویل به دفاتر این منطقه را در ساعات بدون ترافیک (۱۱ تا ۱۲:۳۰) برنامه‌ریزی می‌کند. منوی روزانه ترکیبی از غذای ایرانی و گزینه‌های سبک‌تر.',
        features: [
            'تحویل قبل از اوج ترافیک عصر',
            'پوشش مسیر رسالت تا حکیمیه',
            'منوی ترکیبی روزانه',
            'هماهنگی با راننده شرکتی برای تحویل سریع',
        ],
        nearby: ['narmak', 'tehranpars', 'sayyad-shirazi', 'shariati'],
    },
    {
        slug: 'sayyad-shirazi',
        name: 'صیاد شیرازی',
        zone: 'east',
        intro: 'بزرگراه صیاد شیرازی محل دفاتر شرکت‌های متوسط و بزرگ شرق تهران است.',
        body: 'بزرگراه صیاد شیرازی با عبور از مناطق متعدد شرق تهران، مسیر دسترسی به دفاتر اداری متنوع است. شرکت‌های فعال در حوزه پزشکی، فنی و خدمات تخصصی در این منطقه دفتر دارند.\n\n' +
            'آرشه با هماهنگی روزانه به مجموعه‌های صیاد شیرازی سرویس می‌دهد. مناسب دفاتر ۳۰ نفر به بالا.',
        features: [
            'سرویس به دفاتر پزشکی و فنی',
            'منوی روزانه استاندارد',
            'تحویل با هماهنگی ساختمان',
            'مناسب دفاتر ۳۰ نفر به بالا',
        ],
        nearby: ['resalat', 'narmak', 'shariati', 'tehranpars'],
    },
    {
        slug: 'punak',
        name: 'پونک',
        zone: 'west',
        intro: 'پونک منطقه‌ای رو به رشد در غرب تهران با دفاتر اداری متوسط است.',
        body: 'منطقه پونک با موقعیت دسترسی به بزرگراه شهید همت، یکی از مناطق در حال رشد غرب تهران است. شرکت‌های نوپا، استارتاپ‌ها و دفاتر طراحی در ساختمان‌های مدرن منطقه فعال هستند.\n\n' +
            'آرشه به پونک سرویس روزانه با گزینه‌های متنوع منو و هزینه پیک رایگان برای دفاتر ۳۰ نفر به بالا ارائه می‌دهد.',
        features: [
            'سرویس به استارتاپ‌ها و دفاتر مدرن',
            'هزینه پیک رایگان ۳۰ نفر به بالا',
            'منوی متنوع روزانه',
            'تحویل با هماهنگی پارکینگ',
        ],
        nearby: ['shahrak-gharb', 'sadeghieh', 'farahzadi', 'janat-abad'],
    },
    {
        slug: 'sadeghieh',
        name: 'صادقیه',
        zone: 'west',
        intro: 'میدان صادقیه و خیابان آیت‌الله کاشانی محل دفاتر تجاری و شرکت‌های متوسط است.',
        body: 'منطقه صادقیه و خیابان آیت‌الله کاشانی، یکی از پررفت‌و‌آمدترین مراکز تجاری غرب تهران است. دفاتر شرکت‌های واردات، توزیع، فروشگاهی و خدمات تخصصی در ساختمان‌های اطراف صادقیه متمرکز هستند.\n\n' +
            'آرشه برای شرکت‌های صادقیه با هماهنگی ترافیک سنگین منطقه، تحویل قبل از ساعت ۱۲ را تضمین می‌کند.',
        features: [
            'تحویل قبل از اوج ترافیک ظهر',
            'سرویس به دفاتر تجاری و واردات',
            'منوی روزانه متنوع',
            'فاکتور رسمی برای حسابداری',
        ],
        nearby: ['punak', 'janat-abad', 'shahrak-gharb', 'kashani'],
    },
    {
        slug: 'janat-abad',
        name: 'جنت‌آباد',
        zone: 'west',
        intro: 'جنت‌آباد منطقه‌ای ترکیبی از مسکونی و دفاتر اداری در غرب تهران است.',
        body: 'محله جنت‌آباد با تراکم بالای ساختمان‌های ترکیبی، میزبان دفاتر کوچک و متوسط شرکت‌های مختلف است. آژانس‌های دیجیتال، دفاتر مشاوره و آژانس‌های مسافرتی در این منطقه فعال هستند.\n\n' +
            'آرشه به جنت‌آباد سرویس روزانه با گزینه‌های اقتصادی و متنوع ارائه می‌دهد. مناسب دفاتر ۱۵ نفر به بالا.',
        features: [
            'گزینه‌های اقتصادی برای دفاتر کوچک',
            'منوی متنوع روزانه',
            'سرویس به آژانس‌های دیجیتال',
            'تحویل با هماهنگی ساختمان',
        ],
        nearby: ['punak', 'sadeghieh', 'shahrak-qods', 'kashani'],
    },
    {
        slug: 'shahrak-qods',
        name: 'شهرک قدس',
        zone: 'west',
        intro: 'شهرک قدس (غرب) محل دفاتر فنی و شرکت‌های فناوری غرب تهران است.',
        body: 'شهرک قدس با ساختمان‌های اداری مدرن، یکی از قطب‌های فناوری غرب تهران است. شرکت‌های توسعه نرم‌افزار، فین‌تک و خدمات IT در این منطقه فعال هستند.\n\n' +
            'آرشه با شناخت ذائقه تیم‌های جوان فناوری، منوی متنوعی شامل غذای ایرانی، فست‌فود سالم و گزینه‌های گیاهی ارائه می‌دهد.',
        features: [
            'منوی متناسب با تیم‌های فناوری',
            'گزینه‌های گیاهی و فست‌فود سالم',
            'سرویس به شرکت‌های نرم‌افزاری',
            'تحویل با هماهنگی ساختمان',
        ],
        nearby: ['shahrak-gharb', 'punak', 'farahzadi', 'sadeghieh'],
    },
    {
        slug: 'farmanieh',
        name: 'فرمانیه',
        zone: 'north',
        intro: 'فرمانیه محل دفاتر مدیریتی و سفارت‌خانه‌ها است — آرشه سرویس پریمیوم برای این مجموعه‌ها ارائه می‌دهد.',
        body: 'محله فرمانیه به دلیل موقعیت ویژه شمال تهران و نزدیکی به سفارت‌خانه‌ها، محل دفاتر مدیریتی و شرکت‌های تخصصی سطح بالا است. تقاضای منطقه برای کیفیت بالا و سرویس متمایز است.\n\n' +
            'آرشه برای شرکت‌های فرمانیه منوی پریمیوم با ارائه شیک و گزینه‌های ویژه فراهم می‌کند. مناسب دفاتر مدیریتی و جلسات هیئت‌مدیره.',
        features: [
            'منوی پریمیوم برای دفاتر مدیریتی',
            'ارائه شیک مناسب جلسات',
            'گزینه‌های ویژه و سالم',
            'هماهنگی با نگهبانی ساختمان‌های لوکس',
        ],
        nearby: ['niavaran', 'pasdaran', 'qeytarieh', 'tajrish'],
    },
    {
        slug: 'sheikh-bahaei',
        name: 'شیخ بهایی',
        zone: 'center',
        intro: 'بزرگراه شیخ بهایی محل ساختمان‌های اداری مدرن و دفاتر شرکت‌های متوسط است — آرشه از آشپزخانه‌ی سهروردی، با گذر از همت روزانه به این منطقه سرویس می‌دهد.',
        body: 'بزرگراه شیخ بهایی با عبور از مناطق ونک و سعادت‌آباد، یکی از مسیرهای اصلی شرکت‌های متوسط و بزرگ منطقه شمال غرب تهران است. ساختمان‌های اداری مدرن این بزرگراه پذیرای انواع کسب‌وکارها هستند.\n\n' +
            'آرشه با برنامه‌ریزی دقیق ساعت تحویل، از ترافیک سنگین صبحگاهی همت و چمران عبور می‌کند تا وعده ناهار به‌موقع به دست دفاتر شما برسد.',
        features: [
            'برنامه‌ریزی تحویل قبل از اوج ترافیک',
            'منوی روزانه متنوع',
            'فاکتور رسمی برای واحد حسابداری',
            'هزینه پیک قابل توافق برای حجم بالا',
        ],
        nearby: ['saadat-abad', 'vanak', 'farahzadi', 'shahrak-gharb'],
    },
    {
        slug: 'gandi',
        name: 'گاندی',
        zone: 'center',
        intro: 'خیابان گاندی محل دفاتر شرکت‌های بزرگ ایرانی و چندملیتی است — آرشه روزانه به این منطقه سرویس می‌دهد.',
        body: 'خیابان گاندی با ساختمان‌های اداری بلندمرتبه، یکی از کلاسیک‌ترین خیابان‌های اداری تهران است. شرکت‌های هلدینگ، دفاتر منطقه‌ای شرکت‌های چندملیتی و دفاتر بانکی در این منطقه متمرکز هستند.\n\n' +
            'آرشه با تجربه پذیرایی از مجموعه‌های صدنفری گاندی، فاکتور ماهانه و گزارش تفکیک‌شده برای واحدهای حسابداری بزرگ فراهم می‌کند.',
        features: [
            'سرویس به دفاتر شرکت‌های چندملیتی',
            'پذیرایی سفارش‌های ۱۰۰ نفر به بالا',
            'گزارش تفکیک‌شده برای حسابداری',
            'تحویل با هماهنگی پذیرش ساختمان',
        ],
        nearby: ['vanak', 'mirdamad', 'jordan', 'argentina'],
    },
    {
        slug: 'motahari',
        name: 'مطهری',
        zone: 'center',
        intro: 'خیابان مطهری محل دفاتر اداری متوسط و شرکت‌های خدماتی مرکز تهران است — آرشه با فاصله‌ی کوتاه از سهروردی، تحویل بسیار سریع به این منطقه دارد.',
        body: 'خیابان مطهری از میدان هفت تیر تا تقاطع مفتح، مسیری پرتراکم با ساختمان‌های اداری متعدد است. شرکت‌های خدماتی، دفاتر مشاوره و آژانس‌های دیجیتال در این منطقه فعال هستند.\n\n' +
            'آشپزخانه‌ی مرکزی آرشه در سهروردی شمالی، فقط چند خیابان بالاتر از مطهری قرار دارد. این فاصله‌ی کوتاه به ما اجازه می‌دهد گرم‌ترین وعده ناهار را به دفاتر این خیابان برسانیم.',
        features: [
            'نزدیک‌ترین فاصله از آشپزخانه مرکزی',
            'تحویل سریع و بدون هزینه پیک',
            'منوی روزانه ساده و متنوع',
            'فاکتور ماهانه و گزارش تفکیک‌شده',
        ],
        nearby: ['haft-tir', 'shahid-beheshti', 'argentina', 'mirdamad'],
    },
    {
        slug: 'ferdowsi',
        name: 'فردوسی',
        zone: 'center',
        intro: 'میدان فردوسی محل دفاتر قدیمی، صرافی‌ها و آژانس‌های مسافرتی است.',
        body: 'منطقه میدان فردوسی و خیابان فردوسی، یکی از قدیمی‌ترین مناطق اداری تهران است. صرافی‌ها، آژانس‌های مسافرتی، دفاتر اسناد رسمی و شرکت‌های واردات سنتی در این منطقه فعال هستند.\n\n' +
            'آرشه به دفاتر فردوسی سرویس ناهار روزانه با منوی ساده ایرانی و قیمت مناسب ارائه می‌دهد.',
        features: [
            'سرویس به صرافی‌ها و آژانس‌های مسافرتی',
            'منوی ایرانی ساده',
            'قیمت مناسب برای دفاتر سنتی',
            'تحویل به ساختمان‌های قدیمی',
        ],
        nearby: ['enghelab', 'valiasr', 'haft-tir', 'shahid-beheshti'],
    },
    {
        slug: 'kashani',
        name: 'آیت‌الله کاشانی',
        zone: 'west',
        intro: 'بلوار آیت‌الله کاشانی محل دفاتر تجاری و فروشگاهی غرب تهران است.',
        body: 'بلوار آیت‌الله کاشانی با عبور از مناطق صادقیه و جنت‌آباد، یکی از پرتراکم‌ترین خیابان‌های تجاری اداری غرب تهران است. تراکم بالای دفاتر تجاری و فروشگاهی در این منطقه دیده می‌شود.\n\n' +
            'آرشه به دفاتر کاشانی سرویس روزانه با هماهنگی ترافیک سنگین منطقه ارائه می‌دهد.',
        features: [
            'سرویس به دفاتر تجاری و فروشگاهی',
            'تحویل با هماهنگی ترافیک',
            'منوی روزانه استاندارد',
            'فاکتور ماهانه',
        ],
        nearby: ['sadeghieh', 'janat-abad', 'punak', 'shahrak-qods'],
    },
    {
        slug: 'afsariyeh',
        name: 'افسریه',
        zone: 'east',
        intro: 'افسریه با کارگاه‌ها و دفاتر تولیدی شرق تهران، یکی از قطب‌های صنعتی است.',
        body: 'محله افسریه با تراکم بالای کارگاه‌های تولیدی، انبارها و دفاتر فروش صنعتی، یکی از مناطق صنعتی شرق تهران است. تقاضای منطقه عمدتاً برای وعده‌های پرحجم و اقتصادی است.\n\n' +
            'آرشه برای کارگاه‌های افسریه منوی اقتصادی و پرحجم با گزینه‌های غذای ایرانی سنتی ارائه می‌دهد.',
        features: [
            'منوی اقتصادی و پرحجم',
            'سرویس به کارگاه‌های تولیدی',
            'گزینه‌های ایرانی سنتی',
            'تحویل به انبارها و دفاتر فروش',
        ],
        nearby: ['piroozi', 'tehranpars', 'resalat', 'narmak'],
    },
    {
        slug: 'piroozi',
        name: 'پیروزی',
        zone: 'east',
        intro: 'خیابان پیروزی منطقه‌ای ترکیبی از تجاری، تولیدی و دفاتر اداری شرق تهران است.',
        body: 'خیابان پیروزی با امتداد طولانی خود، انواع مختلفی از کسب‌وکارها را در طول مسیر دارد. کارگاه‌های صنعتی، دفاتر فروش، بانک‌ها و آژانس‌های خدماتی در این منطقه فعال هستند.\n\n' +
            'آرشه به دفاتر پیروزی سرویس روزانه با منوی متنوع و قیمت مناسب ارائه می‌دهد.',
        features: [
            'سرویس به دفاتر تجاری و تولیدی',
            'منوی متنوع روزانه',
            'قیمت مناسب برای کارگاه‌ها',
            'تحویل با هماهنگی صبح',
        ],
        nearby: ['afsariyeh', 'tehranpars', 'narmak', 'resalat'],
    },
    {
        slug: 'tehransar',
        name: 'تهرانسر',
        zone: 'west',
        intro: 'تهرانسر منطقه‌ای رو به رشد در غرب تهران با دفاتر اداری متوسط است.',
        body: 'محله تهرانسر با موقعیت دسترسی به فرودگاه مهرآباد و بزرگراه‌های اصلی، یکی از مناطق در حال رشد غرب تهران است. شرکت‌های لجستیک، آژانس‌های مسافرتی و دفاتر تخصصی در این منطقه فعال هستند.\n\n' +
            'آرشه به تهرانسر با هماهنگی روزانه سرویس می‌دهد. مناسب دفاتر ۲۰ نفر به بالا.',
        features: [
            'سرویس به شرکت‌های لجستیک',
            'مناسب آژانس‌های مسافرتی',
            'منوی متنوع روزانه',
            'تحویل با هماهنگی روز قبل',
        ],
        nearby: ['kashani', 'sadeghieh', 'punak', 'janat-abad'],
    },
    {
        slug: 'darabad',
        name: 'دارآباد',
        zone: 'north',
        intro: 'دارآباد یکی از محلات شمالی تهران با دفاتر مدیریتی و خدمات تخصصی است.',
        body: 'محله دارآباد و اقدسیه، در شمال تهران میزبان دفاتر مدیریتی شرکت‌های متوسط، باشگاه‌های ورزشی و خدمات تخصصی است. تقاضای منطقه برای کیفیت بالا و سرویس متمایز است.\n\n' +
            'آرشه به دارآباد منوی متمایز با ارائه باکیفیت ارائه می‌دهد. مناسب دفاتر کوچک و متوسط.',
        features: [
            'منوی متمایز با کیفیت بالا',
            'سرویس به دفاتر مدیریتی',
            'گزینه‌های سالم و ارگانیک',
            'پذیرایی جلسات و رویدادها',
        ],
        nearby: ['niavaran', 'farmanieh', 'tajrish', 'pasdaran'],
    },
    {
        slug: 'aghdasiyeh',
        name: 'اقدسیه',
        zone: 'north',
        intro: 'اقدسیه محل دفاتر اداری شیک و باشگاه‌های لوکس شمال تهران است.',
        body: 'محله اقدسیه با موقعیت لوکس خود، میزبان دفاتر اداری شیک، باشگاه‌های ورزشی پریمیوم و خدمات تخصصی سطح بالا است. مشتریان این منطقه به‌دنبال کیفیت و سرویس متمایز هستند.\n\n' +
            'آرشه برای شرکت‌های اقدسیه منوی پریمیوم و گزینه‌های ویژه فراهم می‌کند. مناسب دفاتر کوچک تا متوسط با ذائقه خاص.',
        features: [
            'منوی پریمیوم برای مشتریان خاص',
            'گزینه‌های سالم و ارگانیک',
            'سرویس به باشگاه‌های ورزشی',
            'هماهنگی با پذیرش ساختمان',
        ],
        nearby: ['darabad', 'niavaran', 'farmanieh', 'tajrish'],
    },
];
export const DISTRICT_SLUGS = DISTRICTS.map((d) => d.slug);
